import { useEffect, useRef } from 'react';
import siteConfig from '../config/siteConfig';

const CONSENT_EVENT = 'cookie-consent';
const { gaMeasurementId, cookieConsent } = siteConfig;
const consentKey = cookieConsent?.storageKey || 'cookie_consent';

const loadGtag = (gaId, hasConsent, hasLoadedRef) => {
  if (!gaId || hasLoadedRef.current || !hasConsent) return;
  hasLoadedRef.current = true;

  // Mirror the standard gtag snippet while respecting cookie consent.
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', gaId);

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(gtagScript);
};

export default function GoogleAnalytics() {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    const storedConsent = localStorage.getItem(consentKey);
    loadGtag(gaMeasurementId, storedConsent === 'accepted', hasLoadedRef);

    const handler = (event) => {
      if (event?.detail === 'accepted') {
        loadGtag(gaMeasurementId, true, hasLoadedRef);
      }
    };
    document.addEventListener(CONSENT_EVENT, handler);
    return () => document.removeEventListener(CONSENT_EVENT, handler);
  }, []);

  return null;
}
